export default "__VITE_ASSET__Ct9By6TR__"